/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-3",
    "aws_cloud_logic_custom": [
        {
            "name": "virbacconnectApi",
            "endpoint": "https://q7pyqe8b88.execute-api.eu-west-3.amazonaws.com/prod",
            "region": "eu-west-3"
        }
    ],
    "aws_cognito_region": "eu-west-3",
    "aws_user_pools_id": "eu-west-3_x5t7XAJKD",
    "aws_user_pools_web_client_id": "3df5uvlsrcujbbjbj7mskb8gh",
    "oauth": {
        "domain": "cognito-connect.virbac.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://connect.virbac.com",
        "redirectSignOut": "https://connect.virbac.com/logout",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "virbacconnect-hostingbucket-prod",
    "aws_content_delivery_bucket_region": "eu-west-3",
    "aws_content_delivery_url": "https://d2ul0l0fe0bsad.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-west-3",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "virbacconnect-prod-dynamodb-table-clients",
            "region": "eu-west-3"
        },
        {
            "tableName": "virbacconnect-prod-dynamodb-table-codes",
            "region": "eu-west-3"
        }
    ]
};


export default awsmobile;
